import { render, staticRenderFns } from "./ProductSafetyModal.vue?vue&type=template&id=5c2be13d&scoped=true&"
import script from "./ProductSafetyModal.vue?vue&type=script&lang=js&"
export * from "./ProductSafetyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2be13d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\SchuckerP\\git\\plenty-plugins\\4024\\15\\modeherz\\plugin-ceres\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2be13d')) {
      api.createRecord('5c2be13d', component.options)
    } else {
      api.reload('5c2be13d', component.options)
    }
    module.hot.accept("./ProductSafetyModal.vue?vue&type=template&id=5c2be13d&scoped=true&", function () {
      api.rerender('5c2be13d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/modeherz/components/item/ProductSafetyModal.vue"
export default component.exports